module.exports = __webpack_public_path__ + "static/media/logo.6639b1ef.png";